/* -- Generated File: Do Not Edit ------------------------------------------ */
export const fontWeights = {
  fontWeight0: '400',
  fontWeight1: '600',
  fontWeight2: '700',
  fontWeight3: '800',
};

export default fontWeights;
/* -- Generated File: Do Not Edit ------------------------------------------ */
